document.querySelectorAll('.modal__submit, .modal__close, *[data-modal-close]').forEach((el) => {
    el.addEventListener('click', (e) => {
        closeModal(el.closest('.modal'));
    })
})
document.querySelectorAll('*[data-modal]').forEach((el) => {
    el.addEventListener('click', (e) => {
        if(el.dataset.modalMobile ? window.$isMobile : true) {
            e.preventDefault();
            //window.scrollTo(0, 0);
            openModal(el.dataset.modal);
        }
    })
});

function setSizeScrollVar() {
    const size = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.setProperty('--scroll-size', `${size}px`);
}

const modalRegexp = /modal=([^&]*)/
if (modalRegexp.test(location.search)) {
    const modalName = location.search.match(modalRegexp)[1];
    openModal(`.${modalName}`);
}


function getBgModal(el) {
    const div = document.createElement('div');
    div.className = 'modal-background';
    div.addEventListener('click', () => closeModal(el));
    return div;
}

function openModal(modalName) {
    setSizeScrollVar();
    const modalEl = document.querySelector(modalName);
    modalEl.dispatchEvent(new CustomEvent('open'));
    modalEl.classList.add('modal--active');
    modalEl.parentElement.append(getBgModal(modalEl));
    if(!window.$isMobile) {
        ClickOutside.addListener(modalEl, () => closeModal(modalEl));
    }
    document.body.classList.add('modal-open');
    document.body.classList.add('modal-name-'+modalEl.classList[0]);

    setTimeout(() => {
        document.body.classList.add('modal-open--animation-open');
        modalEl.classList.add('modal--animation-open');
    }, 10);
}

function closeModal(modalEl) {
    if(typeof modalEl === 'string') {
        modalEl = document.querySelector(modalEl);
    }
    modalEl.dispatchEvent(new CustomEvent('close'));
    modalEl.classList.remove('modal--animation-open');

    document.body.classList.forEach((name) => {
        if(name.includes('modal-name-')) {
            modalEl.classList.remove(name);
        }
    })

    setTimeout(() => {
        modalEl.classList.remove('modal--active');
    }, 300);

    ClickOutside.removeListener(modalEl);
    const bg = modalEl.parentElement.querySelector('.modal-background');
    if(!document.body.querySelectorAll('.modal--animation-open').length) {
        document.body.classList.remove('modal-open--animation-open');

        setTimeout(() => {
            document.body.classList.remove('modal-open');
            if(bg) {
                bg.remove();
            }
        }, 300);
    }
}
